/*@ngInject*/
const LoadingBarController = function($scope, coreConstant, localization) {

    this.$onInit = function() {
        this.isLoading = false;
    };

    $scope.$on(coreConstant.event.SHOW_LOADING_BAR, function(event, messageKey) {
        this.setMessage(messageKey);
        this.isLoading = true;
    }.bind(this));

    $scope.$on(coreConstant.event.HIDE_LOADING_BAR, function() {
        this.isLoading = false;
    }.bind(this));

    this.setMessage = function(messageKey) {
        if(_.isNil(messageKey)) {
            messageKey = 'loadingBar.defaultMessage';
        }
        localization.getTranslationByKey(messageKey).then(function (translation) {
            this.message = translation || messageKey;
        }.bind(this));
    };

    this.setMessage('loadingBar.defaultMessage');

};

angular.module('umCore')
    .controller('loadingBarController', LoadingBarController);
